import { HttpInterceptorFn } from '@angular/common/http'
import { tokenInterceptor } from './token.interceptor'
import { refreshTokenInterceptor } from './refresh-token.interceptor'
import { qaBaggageInterceptor } from './qa-baggage.interceptor'
import { progressStepInterceptor } from '@features/progress/progress-step.interceptor'
import { apiPrefixInterceptor, errorHandlerInterceptor, retryAbortedXhrInterceptor, retryInterceptor } from '@sun-finance/utils'

export const interceptors: HttpInterceptorFn[] = [
  progressStepInterceptor,
  tokenInterceptor,
  refreshTokenInterceptor,
  qaBaggageInterceptor,
  apiPrefixInterceptor,
  retryInterceptor,
  retryAbortedXhrInterceptor,
  errorHandlerInterceptor,
]
